import type { IdZonaRebatimentoPainel } from '../../dominio/didatico/rebatimentoPainel'
import { xDaEstruturaNaAltura, zDaColunaNaAltura, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { IdPortaOficina } from './zonasOperacaoPorta'

export function pontosRebatimentoPainel(perfil: PerfilVeiculo, idPorta: IdPortaOficina, deslocamento = 0) {
  const sinal = idPorta.endsWith('Esquerda') ? 1 : -1
  const yMedio = perfil.cinturaY + (perfil.tetoY - perfil.cinturaY) * 0.35
  const yBase = perfil.topoSoleiraY + 0.07
  const coluna = (y: number, desloca = 0): [number, number, number] => [
    xDaEstruturaNaAltura(perfil, sinal, y), y + desloca * 0.4,
    (y < perfil.cinturaY
      ? perfil.portaDianteira.zDianteiro + (perfil.colunaA.zBase - perfil.portaDianteira.zDianteiro)
        * Math.max(0, Math.min(1, (y - perfil.topoSoleiraY) / (perfil.cinturaY - perfil.topoSoleiraY)))
      : zDaColunaNaAltura(perfil, perfil.colunaA, y)) + desloca,
  ]
  return {
    sinal, yMedio, yBase, coluna,
    corteMedio: coluna(yMedio),
    corteBase: coluna(yBase),
    baseExtensor: [xDaEstruturaNaAltura(perfil, sinal, perfil.topoSoleiraY) - sinal * 0.03, perfil.topoSoleiraY + 0.16, perfil.colunaB.z + 0.08] as [number, number, number],
    cabecaExtensor: coluna(yMedio - 0.07, deslocamento),
  }
}

export function zonaRebatimentoPorId(perfil: PerfilVeiculo, idPorta: IdPortaOficina, id: IdZonaRebatimentoPainel, deslocamento = 0) {
  const pontos = pontosRebatimentoPainel(perfil, idPorta, deslocamento)
  const posicoes: Record<IdZonaRebatimentoPainel, [number, number, number]> = {
    colunaAMedia: pontos.corteMedio,
    colunaABase: pontos.corteBase,
    baseExtensor: pontos.baseExtensor,
    apoioColunaA: pontos.cabecaExtensor,
  }
  return { id, posicao: posicoes[id], anguloGraus: id === 'colunaAMedia' || id === 'colunaABase' ? 90 : 0 }
}

/** O corpo tem tamanho fixo; só as hastes mudam de curso para ligar os apoios. */
export function poseExtensorEntrePontos(base: [number, number, number], cabeca: [number, number, number]) {
  const distancia = Math.hypot(...cabeca.map((n, i) => n - base[i]))
  const escala = 1.25
  // CilindroTelescopicoHolmatro3D: garra traseira em -0,54 e frontal em 0,04 + curso.
  const progresso = Math.max(0, Math.min(1, (distancia / escala - 0.58) / 0.72))
  return { distancia, escala, progresso, offsetOrigem: 0.54 * escala }
}
